"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyTypeEnum = void 0;
/** 产品二级形态 */
var PropertyTypeEnum;
(function (PropertyTypeEnum) {
    /** 云服务 */
    PropertyTypeEnum["CloudService"] = "CloudService";
    /** 软件 */
    PropertyTypeEnum["Software"] = "Software";
    /** 硬件 */
    PropertyTypeEnum["Hardware"] = "Hardware";
    /** 服务 */
    PropertyTypeEnum["Service"] = "Service";
    /** 内容 */
    PropertyTypeEnum["Content"] = "Content";
    /** 其他 */
    PropertyTypeEnum["Others"] = "Others";
})(PropertyTypeEnum || (exports.PropertyTypeEnum = PropertyTypeEnum = {}));
